import { render, staticRenderFns } from "./date-table.vue?vue&type=template&id=5081aa98&scoped=true"
import script from "./date-table.vue?vue&type=script&lang=ts"
export * from "./date-table.vue?vue&type=script&lang=ts"
import style0 from "./date-table.vue?vue&type=style&index=0&id=5081aa98&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5081aa98",
  null
  
)

export default component.exports